module.exports = __webpack_public_path__ + "static/img/image_add_to_homescreen_finger@3x.16c535d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/image_add_to_homescreen_finger@3x.png
// module id = 239
// module chunks = 18